var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasDeadline)?_c('a-statistic-countdown',{attrs:{"value":_vm.value},on:{"finish":function($event){return _vm.$emit('finish')}}}):_c('span',{staticClass:"activity-countdown-empty"},[_vm._v("— : — : —")])
}
var staticRenderFns = []

export { render, staticRenderFns }